// MUST be first: sets webpack's runtime public path so code-split chunks
// load from the /land-ai sub-path instead of root (regression #953). Import
// before App / anything that can trigger a dynamic import().
import './utils/publicPath';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './App.css';
import { installGlobalErrorHandlers } from './services/errorReporter';
import { getBasePath } from './utils/basePath';

// Capture uncaught errors and unhandled promise rejections,
// sending them to the backend so log watchers can detect them.
installGlobalErrorHandlers();

// Opt into the React Router v7 future-flag behavior now so the v6
// deprecation warnings stop firing and the eventual v7 upgrade is a
// no-op. The two flags we need:
//
//   v7_startTransition: wraps state updates in React.startTransition,
//     making router transitions interruptible. Already compatible with
//     all of our pages.
//
//   v7_relativeSplatPath: changes how relative routes resolve inside
//     splat routes. We don't have any nested splat routes today
//     (the only "*" route is the catch-all redirect to "/"), so this
//     is a no-op for our app.
const routerFutureFlags = {
  v7_startTransition: true,
  v7_relativeSplatPath: true,
};

// When the app is served from a reverse-proxy sub-path (e.g.
// orbital-laser.com/land-ai), the Router MUST be told the same basename,
// otherwise it matches window.location.pathname ("/land-ai/...") against
// routes defined at "/" and renders nothing in <main> while the always-on
// navbar still shows. We detect the mount prefix at RUNTIME from the
// (nginx-rewritten) bundle script URL — no build-time PUBLIC_URL, no rebuild.
// At a root deploy getBasePath() returns "" → basename undefined → default "/".
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename={getBasePath() || undefined} future={routerFutureFlags}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
